import React from 'react';
import { FormattedMessage } from 'react-intl/dist';

import { APP_STATUSES, APP_STATUS_INDICATORS } from '../../../constants/individualPortal/dashboard/dashboardModelTypes';

const AppStatusIndicator = ({ appStatus }) => {
  
    const processStatus = (appStatus) => {
        switch (appStatus) {
            case APP_STATUSES.SG:
            case APP_STATUSES.SU:
                return APP_STATUS_INDICATORS.ERROR;
            case APP_STATUSES.OP:
            case APP_STATUSES.UC:
                return APP_STATUS_INDICATORS.IN_PROGRESS;
            case APP_STATUSES.ER:
            case APP_STATUSES.EN:
            case APP_STATUSES.PN:
                return APP_STATUS_INDICATORS.COMPLETED;
            case APP_STATUSES.CC:
                return APP_STATUS_INDICATORS.CANCELLED;
            case APP_STATUSES.CL:
                return APP_STATUS_INDICATORS.CLOSED;
            default:
                break;
        }
    };

    const status = processStatus(appStatus);

    return (
        <div className={`app-status-indicator ${status.modifierClassName}`}>
            <FormattedMessage id={status.msgKey}/>
        </div>
    );
};

export default AppStatusIndicator;